import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MorePage } from './more.page';
import { PATHS } from '../shared/constants/paths';

const routes: Routes = [
  {
    path: '',
    component: MorePage,
  },
  {
    path: PATHS.PRODUCTS_DEALS_MENU,
    loadChildren: () =>
      import(
        './menu-pages/products-deals-menu/products-deals-menu.module'
      ).then(m => m.ProductsDealsMenuPageModule),
  },
  {
    path: PATHS.MY_BUSINESS_MENU,
    loadChildren: () =>
      import('./menu-pages/my-business-menu/my-business-menu.module').then(
        m => m.MyBusinessMenuPageModule,
      ),
  },
  {
    path: PATHS.MY_ORDERS_MENU,
    loadChildren: () =>
      import('./menu-pages/my-orders-menu/my-orders-menu.module').then(
        m => m.MyOrdersMenuPageModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MorePageRoutingModule {}
